<template>
  <div>
    <q-field
        borderless
        v-model="fieldValue"
        :rules="field.required ? [ val => val && val.length > 0 || requiredText] : []"
    >
    <div class="q-py-sm q-gutter-md mw-form-v2-btn-gutter">

      <template
          v-for="(option, index) in optionsForSelect"
          :key="index"
      >
        <div
            class="mw-form-v2-btn-custom"
            :class="[{ 'mw-form-v2-btn-custom-active': fieldValue === option.value}, classNameFromValue(option.value)]"
           @click="currentVersion = screensVisibilityVersion; fieldValue = option.value">
          <div v-if="debug" class="q-pa-none q-ma-none q-gutter-md">
            <q-badge  color="primary" >
              .mw-form-v2-btn-custom.{{classNameFromValue(option.value)}}<span v-if="fieldValue === option.value">.mw-form-v2-btn-custom-active</span>
            </q-badge>
          </div>
          <div class="mw-form-v2-btn-custom-top"></div>
          <div class="mw-form-v2-btn-custom-label">{{option.label}}</div>
          <div class="mw-form-v2-btn-custom-bottom"></div>
        </div>
      </template>

    </div>
    </q-field>
  </div>

</template>

<script>
import {mapFields} from "vuex-map-fields";
import {mapActions} from "vuex";
export default {
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {
      value: null,
      currentVersion: null
    };
  },
  emits: ['update:modelValue'],
  methods: {
    ...mapActions({
      next: 'values/list/next',
      nextScreen: 'values/list/nextScreen'
    }),
    classNameFromValue(type) {
      return 'field_value_' + type.replace('.','_').replace(' ','_').toLowerCase()
    },
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings',
      form: 'form',
    }),
    ...mapFields('values/list', {
      fieldValues: 'fieldValues',
      activeScreen: 'activeScreen',
      fieldsVisibility: 'fieldsVisibility',
      screensVisibility: 'screensVisibility',
      debug: "debug",
      screensVisibilityVersion: "screensVisibilityVersion"
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select something';
    },
    optionsForSelect: function () {
      let data = [];
      for (const [key, value] of Object.entries(this.field.options)) {
        data.push( {
          label: value,
          value: key
        });
      }
      return data;
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },

  },
  watch: {
    screensVisibilityVersion: function (version) {
      if(this.currentVersion === version -1 && this.field.submit_on_value_set) {
        this.nextScreen({form : this.form});
      }
    }
  },
  mounted() {

  }
}
</script>
